export enum ELocalStorageVariables {
    AUTH_TOKEN = 'authToken',
    FIRST_NAME = 'firstName',
    DECLINED_DUE_TO_SERVICING = 'declinedDueToServicing',
    SESSION_ID = 'sessionId',
}
